module.exports = __webpack_public_path__ + "static/media/boat-img-16.48505973.jpg";